import * as wrapActions from "./wrap-actions"

export default function EditorAutosuggestRefsPlugin() {
  return {
    statePlugins: {
      editor: {
        wrapActions,
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/editor-autosuggest-refs/index.js